.root {
  display: block;
  font-size: 0.875rem;
  line-height: 1;
}
